import { SchemasRoot } from '../constants.js';

export enum ProfileSchemaId {
  LATEST = `${SchemasRoot}/profile/2.0.0.json`,
}
